import AuthState from "models/authState";
import { createContext } from "react";
import { AuthContextProps } from "./authContextProps";

const AuthContext = createContext<AuthContextProps>({
  state: AuthState.UnAuthorized,
});

export default AuthContext;
